import React from 'react'
import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
// eslint-disable-next-line @vio/custom-rules/prefer-usebrand-hook -- This component always displays the Vio logo, not a dynamic brand
import {brands} from '@vio/core/src/brand/config'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {BrandLogo} from '../BrandLogo'
import {PoweredByInteractive} from './PoweredByInteractive'

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
  white-space: nowrap;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s100};
  width: max-content;
`

export const PoweredBy = ({className}: Props) => {
  return (
    <PoweredByInteractive>
      <Container className={className} data-id="powered-by">
        <Text tag="span" variant="bodyXS">
          <FormattedMessageWrapper
            id="partners.poweredBy"
            defaultMessage="Powered by"
          />
        </Text>
        <LogoWrapper>
          <BrandLogo brand={brands.vio} height={16} alt={brands.vio.name} />
          <PoweredByInteractive interactive={false} />
        </LogoWrapper>
      </Container>
    </PoweredByInteractive>
  )
}
